const endpoint = process.env.REACT_APP_ENDPOINT_LAMBDA_STRIPE_DELETE_SUBS;
export default endpoint;
